import React from 'react';
import { Field } from 'redux-form';
import { required, SelectInput } from 'react-admin';

const ValidateRequired = required();

type Props = {
  lookupProperties: string[],
  handleChoiceChange: any,
  item: string
};

const PropertyOption = (props: Props) => (
  <div style={{ flex: '1' }}>
    <Field
      choices={props.lookupProperties}
      component={SelectInput}
      label="Name"
      name={`${props.item}.name`}
      onChange={(event, name, value) => props.handleChoiceChange(event, name, value)}
      source={`${props.item}.name`}
      validate={ValidateRequired} />
  </div>
);

export default PropertyOption;



// WEBPACK FOOTER //
// ./src/views/Common/Partials/Properties/PropertyOption.tsx